import { setCurrency, setNumberWithPoint } from 'utils/utils'
import { Badge, Button } from 'avo-ui'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'

export const TABLE_SETTING_POINT_COLLECTION = {
    name: 'Point Collection',
    column: [
        {
            name: 'Nama Activity',
            key: 'name',
            className: 'capitalize',
            render: ({ value }) => <div>{value?.replace('-', ' ')}</div>,
        },
        {
            name: 'Nilai Point',
            key: 'total_point',
            render: ({ value }) => <div>{value >= 0 ? `${setNumberWithPoint(value)} Point` : '-'}</div>,
        },
        {
            name: 'Min. Order',
            key: 'min_transaction',
            render: ({ value }) => <div>{value >= 0 ? setCurrency(value) : '-'}</div>,
        },
        {
            name: 'Max. Point',
            key: 'max_amount',
            render: ({ value }) => <div>{value >= 0 ? `${setNumberWithPoint(value || 0)} Point` : '-'}</div>,
        },
        {
            name: 'Status',
            key: 'is_active',
            render: ({ value }) => <Badge title={value ? 'Active' : 'Inactive'} type={value ? 'active' : 'inactive'} />,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button type={'outline'} title={'Edit'} icon={icEditYellow} onClick={() => onClickItem(item)} />
            ),
        },
    ],
}
